/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementDeleteItemResponse } from './CarpsaleManagementDeleteItemResponse';

export type CarpsaleManagementDeleteItemResponseApiRespoonse = {
    data?: CarpsaleManagementDeleteItemResponse;
    status?: CarpsaleManagementDeleteItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementDeleteItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

